import createSvgIcon from '@mui/material/utils/createSvgIcon.js';
import React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m21.1579 6.151-1.2918 2.1745-1.2919-2.1744-2.8421-.9884 2.8421-.9883L19.8661 2l1.2918 2.1744L24 5.1627zM0 12.9146l11.455 4.8319 11.4551-4.8319-11.4551-4.832zm.5988 3.483 10.8562 4.5702 10.8563-4.5702-2.1868-.9261-8.6695 3.6642-8.6693-3.6642zm17.9636-3.483-7.1074 2.9998-7.1073-2.9998 7.1073-2.9999z"
    clipRule="evenodd"
  />,
  'Analyze',
);
